/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AccountCategory = {
    Asset: 'Asset',
    Liability: 'Liability',
    Equity: 'Equity',
    Revenue: 'Revenue',
    ContraRevenue: 'ContraRevenue',
    Expense: 'Expense'
} as const;
export type AccountCategory = typeof AccountCategory[keyof typeof AccountCategory];


export function instanceOfAccountCategory(value: any): boolean {
    for (const key in AccountCategory) {
        if (Object.prototype.hasOwnProperty.call(AccountCategory, key)) {
            if (AccountCategory[key as keyof typeof AccountCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AccountCategoryFromJSON(json: any): AccountCategory {
    return AccountCategoryFromJSONTyped(json, false);
}

export function AccountCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountCategory {
    return json as AccountCategory;
}

export function AccountCategoryToJSON(value?: AccountCategory | null): any {
    return value as any;
}

export function AccountCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): AccountCategory {
    return value as AccountCategory;
}

